import { MiniEventCard, renderMarketsRegular } from "../../../components";

export class Regular extends MiniEventCard {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.cardTypeClass = `rj-ev-list__${this.componentPrefix}--regular`;
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder--regular`;
    }

    renderMarkets = renderMarketsRegular;
}